module.exports = __webpack_public_path__ + "static/img/dyjfhj.5b924c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/dyjfhj.png
// module id = mG+O
// module chunks = 0